module.exports = __webpack_public_path__ + "bdaa5112cb11684713c6fa53fd782dee.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-13.png
// module id = 1661
// module chunks = 0